import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import FormImage from '@shared/atoms/FormFields/FormImage';
import theme from '@shared/themes/default';
import { PROCESSING_STATUS } from '@shared/const';

import { useAppGlobals } from '../../../../contexts/AppContext';
import { getStaticImagesHostname } from '../../../../../config';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`;

const UploadsTab = ({ handleChange, values, properties }) => {
  const { getRestClient } = useAppGlobals();
  const { t } = useTranslation();
  const { picture, signature } = values;

  const handleAddImage = (name, file) => {
    handleChange({
      name,
      value: {
        base64: file.base64,
        processingStatus: PROCESSING_STATUS.TO_SCHEDULE,
        key: file.s3File.key,
      },
    });
  };

  const handleDeleteImage = (name) => {
    handleChange({
      name,
      value: null,
    });
  };

  return (
    <Wrapper>
      <FormImage
        handleAdd={(file) => handleAddImage('picture', file)}
        handleDelete={() => handleDeleteImage('picture')}
        id="picture"
        infoText={t('backoffice.experts.uploadTab.horizontalInfo')}
        imgUrl={
          picture?.processingStatus === PROCESSING_STATUS.PROCESSED ||
          picture?.processingStatus === PROCESSING_STATUS.TO_SCHEDULE
            ? picture.base64 || `${getStaticImagesHostname()}/${picture.key}`
            : null
        }
        name="picture"
        processingStatus={picture?.processingStatus}
        properties={properties}
        restClient={getRestClient()}
        small
        title={t('backoffice.experts.uploadTab.horizontal')}
      />
      <FormImage
        colorBackground={signature && theme.palette.lightInteracting}
        handleAdd={(file) => handleAddImage('signature', file)}
        handleDelete={() => handleDeleteImage('signature')}
        id="signature"
        infoText={t('backoffice.experts.uploadTab.signatureInfo')}
        imgUrl={
          signature?.processingStatus === PROCESSING_STATUS.PROCESSED ||
          signature?.processingStatus === PROCESSING_STATUS.TO_SCHEDULE
            ? signature.base64 ||
              `${getStaticImagesHostname()}/${signature.key}`
            : null
        }
        name="signature"
        processingStatus={signature?.processingStatus}
        properties={properties}
        restClient={getRestClient()}
        small
        title={t('backoffice.experts.uploadTab.signature')}
      />
    </Wrapper>
  );
};

UploadsTab.propTypes = {
  handleChange: PropTypes.func.isRequired,
  properties: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
};

export default UploadsTab;
